import { controls, currencyToNumber, grouped } from "../../controls";


const pcmc_employee_attendance = {
  label: "Pcmc Employees Attendance Details",
  url: "pcmc_employee_attendance",
  pageLabel: "Pcmc Employees Attendance Details",
  pageType: "history",
  filter: [ 
          ...controls.displayText({ tab: "filter", label: "Employee"}),
          ...controls.oc({ tab: "filter", c: "Employee", placeHolder: "Employee Code", name: "employee_code",fastpath: "employees"}),
          ...controls.showData({ tab: "filter", displaytype: "capital", data: "employee_display"}),
            
           ...controls.magicDateLabel({ tab: "general", label: "From Date",target: "from_date"}),
           ...controls.magicDate({ tab: "general", name: "from_date", dateType: "ontype"}),
           ...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
           
           ...controls.magicDateLabel({ tab: "general", label: "To Date",target: "to_date"}),
           ...controls.magicDate({ tab: "general", name: "to_date", dateType: "ontype"}),
         //  ...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Pcmc Employees Attendance Details",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },

    filterable:true,
    sortable: true,
    defaultsTo: 0,
   textReportProps: {
      '132': {
        filename: `Pcmc Employees Attendance Details-$pageData.as_on_date$.oro`,
        empty:true,//true
        format: {},
        header: "default",
        footer: "default"
      },
    },
    reportProps: { searchable: true, sortable: true },
     displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }//3
      },
    
      {
        Header: "Employee Code",
        accessor: "employee_code",
        
      },
      {
        Header: "Employee Name",
        accessor: "employee_display",
        
      },
    
      {
        Header: "IN Time",
        accessor: "in_time",
        
      },
      {
        Header:"Out Time",
        accessor:"out_time"
      },
      {
        Header: "IN Branch Name",
        accessor: "in_branch",
       
      },
     
      {
        Header: "Out Branch Name",
        accessor: "out_branch",
      },
     

    ]
  }
};

export default pcmc_employee_attendance;